<style scoped lang="scss">
@import '@/assets/scss/_inputs-shared.scss';
</style>
<template>
        <div class="step4-container">
            <DataConfirmation 
                :quote="stepperData.quote" 
                :all-data="allData"
                @next-step="$emit('next-step')"
                @previous-step="$emit('previous-step')"
                @quote-updated="$emit('quote-updated', $event)"
                ref="dataConfirmation"
            />
            <div style="display: flex; justify-content: center;">
            </div>
        </div>
       
</template>

<script>
import DataConfirmation from '@/components/step4/DataConfirmation.vue'
import localPageTimerMixin from '@/mixins/localPageTimerMixin'

export default {
    name: 'NewVersionStep4',
    mixins: [localPageTimerMixin],
    components: {
        DataConfirmation
    },
    props: {
        stepperData: { type: Object, required: true },
        allData: { type: Object, required: true }
    },
    mounted() {
        // La validación del cupón se maneja automáticamente en DataConfirmation
    }
}
</script>

<style scoped>
.step4-container {
    padding: 20px;
}

/* ===== RESPONSIVE DESIGN ===== */

/* Mobile (≤768px) */
@media (max-width: 768px) {
    .step4-container {
        padding: 16px;
    }
}

/* Mobile Small (320px - 480px) */
@media (max-width: 480px) {
    .step4-container {
        padding: 12px;
    }
}

/* Mobile Extra Small (≤320px) */
@media (max-width: 320px) {
    .step4-container {
        padding: 8px;
    }
}

/* Tablet (768px - 1023px) */
@media (min-width: 769px) and (max-width: 1023px) {
    .step4-container {
        padding: 18px;
    }
}

/* Desktop (1024px+) */
@media (min-width: 1024px) {
    .step4-container {
        padding: 20px;
    }
}

/* Large Desktop (1280px+) */
@media (min-width: 1280px) {
    .step4-container {
        padding: 24px;
    }
}

/* Landscape Mobile */
@media (max-height: 500px) and (orientation: landscape) {
    .step4-container {
        padding: 12px;
    }
}

/* High DPI displays */
@media (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) {
    .step4-container {
        /* Optimizaciones para pantallas de alta densidad */
    }
}

/* Print styles */
@media print {
    .step4-container {
        background: white;
        padding: 20px;
    }
}

/* Accessibility improvements */
@media (prefers-reduced-motion: reduce) {
    .step4-container {
        /* Reducir animaciones si el usuario lo prefiere */
    }
}
</style>
